module.exports = __webpack_public_path__ + "static/img/banner.edfb63e9.jpg";